import { List as TetrisList } from 'modules/List';
import { Container, Title } from './styled';
export function List(props) {
    const { title, children } = props;
    return (<Container>
      {title && (<Title $fontSize="tiny" $appearance="100">
          {title}
        </Title>)}
      <TetrisList>{children}</TetrisList>
    </Container>);
}
